import React from 'react';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { pricing, site } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
const included = ['Los 6 tomos completos en PDF', 'Los 6 bonos de regalo (checklists)', 'Plan de aplicación de 12 meses', 'Acceso inmediato por correo', 'Actualizaciones futuras sin costo', 'Soporte por correo y por Instagram'];
export function Pricing() {
  return <section id="precio" className="w-full bg-forest-900 py-16 lg:py-24" data-id="element-138" data-mp="1vvv2kcaywm78">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-139" data-mp="1ru184lrd8efi">
        <div className="grid gap-10 lg:grid-cols-[1fr_0.85fr] lg:items-start lg:gap-16" data-id="element-140" data-mp="25sr39vumk418">
          <div data-id="element-141" data-mp="20tefn8vxisxl">
            <p className="font-display text-sm font-bold text-gold-500" data-id="element-142" data-mp="20sv88m3wnmxt">
              Precio de lanzamiento
            </p>
            <h2 className="display-tight mt-4 font-display text-4xl font-extrabold text-cream-50 sm:text-5xl" data-id="element-143" data-mp="3h5tionkzmnjt">
              Todo el sistema por menos de lo que gastás en un delivery.
            </h2>
            <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-144" data-mp="3vyx96505i8ho">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-cream-200" data-id="element-145" data-mp="4rkrzpz9pv1r">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-146" data-mp="erbkxn86k1zq" />
                  <span data-id="element-147" data-mp="3daijbl1kl0ig">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl bg-cream-50 p-7 shadow-card lg:p-8" data-id="element-148" data-mp="3i8k5ieualfy5">
            <div className="flex items-center justify-between gap-3" data-id="element-149" data-mp="3n63qrypeqszl">
              <span className="font-display text-[11px] font-bold uppercase tracking-[0.12em] text-forest-700" data-id="element-150" data-mp="3rxljjzha1n9h">
                Pago único
              </span>
              <span className="rounded-md bg-gold-500 px-2.5 py-1 font-display text-[11px] font-extrabold uppercase tracking-wide text-forest-900" data-id="element-151" data-mp="2ui7omeh2k8vf">
                {pricing.discount}
              </span>
            </div>

            <p className="mt-6 text-sm text-forest-700/70" data-id="element-152" data-mp="2mhruttlpjq5r">
              Valor real{' '}
              <span className="line-through" data-id="element-153" data-mp="2mfxj95wbtaec">{pricing.listPrice}</span>
            </p>
            <p className="mt-1 font-display text-5xl font-extrabold text-forest-800 sm:text-6xl" data-id="element-154" data-mp="318qzwunc3wkl">
              {pricing.price}
            </p>
            <p className="mt-3 text-sm font-medium text-forest-600" data-id="element-155" data-mp="28hh3kpghk9k2">
              Ahorrás {pricing.saving} y te llevás los 6 bonos de regalo.
            </p>

            <a id="comprar" href={site.checkoutUrl} onClick={() => trackPixelEvent('InitiateCheckout', {
            value: 19990,
            currency: 'ARS',
            content_name: 'Sistema de Ahorro'
          })} className="mt-7 block scroll-mt-32 rounded-md bg-gold-500 px-6 py-4 text-center font-display text-base font-extrabold uppercase tracking-wide text-forest-900 transition-transform duration-150 ease-out hover:-translate-y-0.5 hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-600" data-id="element-156" data-mp="23l0he0suk59m">
              Quiero el sistema
            </a>

            <ul className="mt-7 space-y-2.5 border-t border-cream-200 pt-6 text-sm text-forest-700/80" data-id="element-157" data-mp="3rfwvhq5fjmqx">
              <li className="flex items-start gap-2" data-id="element-158" data-mp="j0lld0rh65vi">
                <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-159" data-mp="j37qktqw89ak" />
                Garantía de 7 días o te devolvemos todo
              </li>
              <li className="flex items-start gap-2" data-id="element-160" data-mp="e9my1h82k7ir">
                <LockIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-161" data-mp="e8267zd532ol" />
                Pago seguro: Mercado Pago, tarjeta.
              </li>
              <li className="flex items-start gap-2" data-id="element-162" data-mp="3f7ijs5lldsmz">
                <ZapIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-163" data-mp="3f8blut9lvtys" />
                Acceso en minutos, 100% digital
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}